import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
const Card = ({
  benefit,
  delay
}: {
  benefit: any;
  delay: number;
}) => {
  const cardRef = useRef<HTMLDivElement>(null);
  const [rotateX, setRotateX] = useState(0);
  const [rotateY, setRotateY] = useState(0);
  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!cardRef.current) return;
    const rect = cardRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const centerX = rect.width / 2;
    const centerY = rect.height / 2;
    // Reduce the rotation effect for a more subtle 3D tilt
    const rotateXValue = (y - centerY) / centerY * -5;
    const rotateYValue = (x - centerX) / centerX * 5;
    setRotateX(rotateXValue);
    setRotateY(rotateYValue);
  };
  const handleMouseLeave = () => {
    setRotateX(0);
    setRotateY(0);
  };
  return <motion.div ref={cardRef} className="bg-white rounded-2xl p-8 shadow-[0_10px_40px_rgba(0,0,0,0.08)] border border-gray-100 flex flex-col h-full cursor-pointer" initial={{
    opacity: 0,
    y: 50
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    delay,
    duration: 0.6,
    type: 'spring',
    bounce: 0.4
  }} onMouseMove={handleMouseMove} onMouseLeave={handleMouseLeave} animate={{
    rotateX,
    rotateY
  }} style={{
    transformStyle: 'preserve-3d',
    perspective: 1000
  }} data-id="element-31">
      <div className="text-4xl mb-6" style={{
      transform: 'translateZ(30px)'
    }} data-id="element-32">
        {benefit.icon}
      </div>
      <h3 className="text-xl font-bold text-black mb-4" style={{
      transform: 'translateZ(20px)'
    }} data-id="element-33">
        {benefit.title}
      </h3>
      <p className="text-gray-600 mb-8 flex-grow" style={{
      transform: 'translateZ(10px)'
    }} data-id="element-34">
        {benefit.body}
      </p>
      <div className="text-[#D4AF37] font-bold text-sm tracking-wide uppercase mt-auto" style={{
      transform: 'translateZ(20px)'
    }} data-id="element-35">
        → {benefit.arrow}
      </div>
    </motion.div>;
};
export const Benefits = () => {
  const benefits = [{
    icon: '🌐',
    title: 'APARECÉS EN GOOGLE',
    body: 'Clientes nuevos que nunca te vieron en Instagram te encuentran solos.',
    arrow: 'Sin pagar publicidad extra'
  }, {
    icon: '💰',
    title: 'VENDÉS MIENTRAS DORMÍS',
    body: 'Tu página trabaja las 24 horas. Informa, convence y capta clientes sola.',
    arrow: 'Automatizá tus ventas'
  }, {
    icon: '👔',
    title: 'PROYECTÁS PROFESIONALISMO',
    body: 'Primera impresión: un negocio serio, organizado y confiable.',
    arrow: 'Los clientes que dudan, dejan de dudar'
  }, {
    icon: '🔓',
    title: 'LIBERTAD DE ALGORITMOS',
    body: 'Instagram puede cambiar mañana. Tu web no le pertenece a Meta.',
    arrow: 'Te pertenece a vos'
  }, {
    icon: '📍',
    title: 'TODO EN UN SOLO LUGAR',
    body: 'Servicios, precios, contacto, historia, testimonios. Ordenado y claro.',
    arrow: 'Tu negocio completo online'
  }, {
    icon: '⚡',
    title: 'LISTA EN 48 HORAS',
    body: 'No esperás semanas. Tu web personalizada lista en 2 días.',
    arrow: 'Empezá a vender ya'
  }];
  return <section className="py-32 bg-[#F8F9FA] overflow-hidden" data-id="element-36">
      <div className="container mx-auto px-6" data-id="element-37">
        <motion.h2 className="text-3xl md:text-5xl font-serif font-bold text-center text-black mb-20 max-w-3xl mx-auto" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-38">
          Lo que cambia en tu negocio con una web profesional
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-39">
          {benefits.map((b, i) => <Card key={i} benefit={b} delay={i * 0.2} data-id="element-40" />)}
        </div>
      </div>
    </section>;
};